/**************************************************************************************************/
/** @import Node Packages                                                                        **/
/**************************************************************************************************/
import { defineComponent } from 'vue'

/**************************************************************************************************/
/** @import Constants                                                                            **/
/**************************************************************************************************/
import { Breakpoints } from '@/Constants/Breakpoints'

/**************************************************************************************************/
/** @internal Const @name MixinResponsive                                                        **/
/**************************************************************************************************/
const MixinResponsive = defineComponent(
{
	/*************************************************/
	/** @Data                                       **/
	/*************************************************/
	data()
	{
		return {
			responsive:
			{
				currentBreakpoint: undefined as number | undefined
			},
			breakpoints:
			[
				Breakpoints.XSmall,
				Breakpoints.Small,
				Breakpoints.Medium,
				Breakpoints.Large,
				Breakpoints.XLarge,
				Breakpoints.XXLarge,
			]
		}
	},

	/*************************************************/
	/** @Hooks                                      **/
	/*************************************************/
	beforeDestroy() : void
	{
		window.removeEventListener('resize', this.ResizeEventHandler)
	},

	beforeMount() : void
	{
		window.addEventListener('resize', this.ResizeEventHandler)
	},

	created() : void
	{
		this.ResizeEventHandler()
	},

	/*************************************************/
	/** @Computed                                   **/
	/*************************************************/
	computed:
	{
		GetResponsiveClass() : { [key: string]: true }
		{
			const prefix = this.GetBreakpointPrefix()
			return { [`${ prefix }`]: true }
		},

		GetResponsiveClasses() : string | object
		{
			if ((this as any)?.states?.isMobile) return 'mobile'
			return this.GetResponsiveClass
		}
	},

	/*************************************************/
	/** @Methods                                    **/
	/*************************************************/
	methods:
	{
		GetBreakpointPrefix() : string
		{
			switch (this.responsive.currentBreakpoint)
			{
				case Breakpoints.XSmall    : return 'xs'
				case Breakpoints.Small     : return 'sm'
				case Breakpoints.Medium    : return 'md'
				case Breakpoints.Large     : return 'lg'
				case Breakpoints.XLarge    : return 'xl'
				case Breakpoints.XXLarge   : return 'xxl'
				case Breakpoints.Widescreen: return 'ws'
			}
			return ''
		},

		ResizeEventHandler() : void
		{
			const width = window.innerWidth
			const found = this.breakpoints.find((x: any) => width <= x) || Breakpoints.Widescreen
			this.responsive.currentBreakpoint = found
		}
	},

	/*************************************************/
	/** @Watch                                      **/
	/*************************************************/
	watch:
	{
		['responsive.currentBreakpoint'](newVal: number) : void
		{
			if ('OnResponsiveBreakpoint' in this)
			{
				const self: any = this
				self.OnResponsiveBreakpoint(newVal)
			}
		}
	}
})

/**************************************************************************************************/
/** @export Component @name MixinResponsive                                                      **/
/**************************************************************************************************/
export default MixinResponsive